module.exports = __webpack_public_path__ + "static/22-9f0a204353538acdaf1d335a3e011cf4.png";